import React, { useState, Fragment, useEffect } from 'react';
import {
    Row,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    CustomInput,
} from 'reactstrap';
import parse from "html-react-parser";
import { Colxx } from '../../../../../../components/common/CustomBootstrap';

const DynamicFlowTemplate = ({ locale, visible, toggle, getTemplateData, dynamicFlowList, serviceProvider }) => {
    const [dynamicFlowTemplateList, setDynamicFlowTemplateList] = useState([]);
    const [id, setId] = useState("");
    useEffect(() => {
        const updatedList = dynamicFlowList.map(item => ({
            ...item,
            showMore: false
        }));
        setDynamicFlowTemplateList(updatedList);
    }, [locale, dynamicFlowList]);

    const toggleShowmore = (id) => {
        const updatedList = dynamicFlowTemplateList.map(item =>
            item.id === id
                ? { ...item, showMore: !item.showMore }
                : item
        );
        setDynamicFlowTemplateList(updatedList);
    };
    const checkedFlow = (e) => {
        if (e.target.checked) {
            setId(e.target.value);
        }
        if (!e.target.checked) {
            setId("");
        }
    }

    const ImportTempate = () => {
        var data = dynamicFlowTemplateList.filter(l => l.id == id);
        if (data.length > 0) {
            getTemplateData(data[0]);
            toggle();
        }
    }
    const filteredTemplates =
        serviceProvider === "2" || serviceProvider === "5"
            ? dynamicFlowTemplateList.filter(item =>
                item.name?.toLowerCase().includes("synxis") ||
                item.name?.toLowerCase().includes("aven") ||
                item.name?.toLowerCase().includes("hs")
            )
            : dynamicFlowTemplateList;
    console.log('dynamic', filteredTemplates);
    return (<Fragment>
        <Modal isOpen={visible} toggle={() => toggle()} size="lg">
            <ModalHeader toggle={() => toggle()}>
                Dynamic ConversationFlow Templates
            </ModalHeader>
            <ModalBody>
                <Row>
                    <Colxx md="12">
                        {filteredTemplates && filteredTemplates.length > 0 &&
                            filteredTemplates.map((k, i) => (
                                <Row className="mb-3" key={k.id}>
                                    <Colxx md={8}>
                                        <h5>{k.name}</h5>
                                        {k.instructions?.length > 100 ? (
                                            <>
                                                {k.showMore === false ? (
                                                    <Fragment>
                                                        <span>
                                                            {parse(k.instructions.substring(0, 100))}...
                                                        </span>
                                                        <a
                                                            style={{ fontWeight: "600", marginLeft: "15px", cursor: "pointer" }}
                                                            onClick={() => toggleShowmore(k.id)}
                                                        >
                                                            See More
                                                        </a>
                                                    </Fragment>
                                                ) : (
                                                    <Fragment>
                                                        <span>{parse(k.instructions)}</span>
                                                        <a
                                                            style={{ fontWeight: "600", marginLeft: "15px", cursor: "pointer" }}
                                                            onClick={() => toggleShowmore(k.id)}
                                                        >
                                                            See Less
                                                        </a>
                                                    </Fragment>
                                                )}
                                            </>
                                        ) : (
                                            <span>{parse(k.instructions)}</span>
                                        )}
                                    </Colxx>
                                    <Colxx md={4}>
                                        <CustomInput
                                            key={k.id}
                                            type="radio"
                                            id={k.id}
                                            value={k.id}
                                            checked={
                                                k.id === id ? true : false
                                            }
                                            onChange={(e) => checkedFlow(e)}
                                        />
                                    </Colxx>
                                </Row>
                            ))}
                    </Colxx>
                </Row>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={() => ImportTempate()}>
                    Import
                </Button>
                <Button color="secondary" onClick={() => toggle()}>
                    Cancel
                </Button>
            </ModalFooter>
        </Modal>
    </Fragment>)
}
export default DynamicFlowTemplate;